module.exports = __webpack_public_path__ + "static/media/hot-cover-05.0b02548d.jpg";